'use strict';

var React = require('react');
var index = require('./index-b4aa8bee.js');
require('tslib');
require('events');
require('react/jsx-runtime');
require('@emotion/react');
require('react-dom');
require('react-intl');
require('react-hook-form');

/** https://mui.com/api/FormLabel/ */
const FormLabel = (props) => (React.createElement(index.ThemeProvider, { theme: index.theme$3 },
    React.createElement(index.FormLabel, Object.assign({}, props))));

exports.default = FormLabel;
